const apiUrl = process.env.REACT_APP_API_URL;
export const PostRemesaFactura = async (id_remesa: number, page: string, token: string) => {
    try {
        console.log(token);
        console.log(page);
        const response = await fetch(`${apiUrl}:8073/remeses/${id_remesa}/factura`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page,
                'token': token
            }
        });
        if (response.ok) {
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        } else {
            alert(await response.text()); 
        }
        return "";

    } catch (error) {
        console.error('Error al descargar el documento', error);
        return "";
    }
};
